// CARTO public basemap key; this is not a Supabase/database credential.
// Keep the original Positron (light_all) and Dark Matter (dark_all) styles.
const key = 'cb1_3v3j_1_ceac95245e69a80e64a5c425';
export const cartoTileUrl = (style, retina = false) =>
  `https://basemaps.cartocdn.com/${style}/{z}/{x}/{y}${retina ? '{r}' : ''}.png?key=${encodeURIComponent(key)}`;
export const cartoAttribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>';
